import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'wdx-nav-item',
    templateUrl: './wdx-nav-item.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class WdxNavItemComponent {}
